import { has } from "lodash";
import { types } from "./actions";
import { successResponse } from "./selector";
import { error } from "highcharts";

const initialState = {
  list: [],
  error: null,
  loading: false,
  loaded: false,
  isLoading: false,
  isLoaded: false,
  currentCustomData: null,
  currentCustomLoading: false,
  currentCustomLoaded: false,
  successResponse: null,
  removeSuccessResponse: null,
  aliasUnmapList: [],
  isAliasListLoading: false,
  isAliasListLoaded: false,
  currentCustomDataList: null,
  aliasLogLoading: false,
  aliasLogLoaded: false,
  aliasLogs: [],
  customEventList: [],
  total: 0,
  checkCountLoading: false,
  checkCountLoaded: false,
  checkCountResponse: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CUSTOM_DATA: {
      return {
        ...state,
        list: [],
        isLoading: true,
        isLoaded: false,
        error: null,
        successResponse: null,
        removeSuccessResponse: null,
      };
    }
    case types.FETCH_CUSTOM_DATA_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        list: action.payload,
      };
    }
    case types.FETCH_CUSTOM_DATA_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_CUSTOM_DATA: {
      return {
        ...initialState,
      };
    }
    case types.FETCH_CUSTOM_DATA_ALIAS_UNMAP: {
      return {
        ...state,
        aliasUnmapList: [],
        isAliasListLoading: true,
        isAliasListLoaded: false,
      };
    }
    case types.FETCH_CUSTOM_DATA_ALIAS_UNMAP_SUCCESS: {
      return {
        ...state,
        isAliasListLoading: false,
        isAliasListLoaded: true,
        aliasUnmapList: action.payload,
      };
    }
    case types.FETCH_CUSTOM_DATA_ALIAS_UNMAP_FAILED: {
      return {
        ...state,
        isAliasListLoading: false,
        isAliasListLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_DATA: {
      return {
        ...state,
        error: null,
        currentCustomData: null,
        successResponse: null,
        removeSuccessResponse: null,
        currentCustomLoading: true,
        currentCustomLoaded: false,
        currentCustomDataList: null,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_SUCCESS: {
      return {
        ...state,
        currentCustomLoading: false,
        currentCustomLoaded: true,
        currentCustomData: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_FAILED: {
      return {
        ...state,
        currentCustomLoading: false,
        currentCustomLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_LIST: {
      return {
        ...state,
        error: null,
        successResponse: null,
        removeSuccessResponse: null,
        currentCustomDataList: null,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_LIST_SUCCESS: {
      return {
        ...state,
        currentCustomDataList: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_LIST_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.CLEAR_FETCH_A_CUSTOM_DATA_LIST: {
      return {
        ...state,
        currentCustomDataList: null,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_ALIAS: {
      return {
        ...state,
        error: null,
        currentCustomData: null,
        successResponse: null,
        removeSuccessResponse: null,
        currentCustomLoading: true,
        currentCustomLoaded: false,
        currentCustomDataList: null,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_ALIAS_SUCCESS: {
      return {
        ...state,
        currentCustomLoading: false,
        currentCustomLoaded: true,
        currentCustomData: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_ALIAS_FAILED: {
      return {
        ...state,
        currentCustomLoading: false,
        currentCustomLoaded: true,
        error: action.payload,
      };
    }
    case types.DELETE_ALIAS: {
      return {
        ...state,
        error: null,
        successResponse: null,
        removeSuccessResponse: null,
      };
    }
    case types.DELETE_ALIAS_SUCCESS: {
      return {
        ...state,
        successResponse: action.payload,
      };
    }
    case types.DELETE_ALIAS_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.REMOVE_MAPPED_KEY: {
      return {
        ...state,
        error: null,
        successResponse: null,
        removeSuccessResponse: null,
      };
    }
    case types.REMOVE_MAPPED_KEY_SUCCESS: {
      return {
        ...state,
        removeSuccessResponse: action.payload,
      };
    }
    case types.REMOVE_MAPPED_KEY_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.CLEAR_CUSTOM_DATA_DETAILS: {
      return {
        ...state,
        currentCustomLoading: false,
        currentCustomLoaded: false,
        currentCustomData: null,
      };
    }
    case types.CLEAR_CUSTOM_DATA_DETAILS_LOADING: {
      return {
        ...state,
        currentCustomLoading: false,
        currentCustomLoaded: false,
      };
    }
    case types.MAP_TO_ALIAS: {
      return {
        ...state,
        error: null,
        successResponse: null,
        removeSuccessResponse: null,
      };
    }
    case types.MAP_TO_ALIAS_SUCCESS: {
      return {
        ...state,
        successResponse: action.payload,
      };
    }
    case types.MAP_TO_ALIAS_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.CREATE_ALIAS: {
      return {
        ...state,
        error: null,
        successResponse: null,
        removeSuccessResponse: null,
      };
    }
    case types.CREATE_ALIAS_SUCCESS: {
      return {
        ...state,
        successResponse: action.payload,
      };
    }
    case types.CREATE_ALIAS_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.UPDATE_ALIAS: {
      return {
        ...state,
        error: null,
        successResponse: null,
        removeSuccessResponse: null,
      };
    }
    case types.UPDATE_ALIAS_SUCCESS: {
      return {
        ...state,
        successResponse: action.payload,
      };
    }
    case types.UPDATE_ALIAS_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.FETCH_A_ALIAS_LOGS: {
      return {
        ...state,
        aliasLogLoading: true,
        aliasLogLoaded: false,
        aliasLogs: [],
      };
    }
    case types.FETCH_A_ALIAS_LOGS_SUCCESS: {
      return {
        ...state,
        aliasLogLoading: false,
        aliasLogLoaded: true,
        aliasLogs: action.payload,
      };
    }
    case types.FETCH_A_ALIAS_LOGS_FAILED: {
      return {
        ...state,
        aliasLogLoading: false,
        aliasLogLoaded: true,
        aliasLogs: [],
        error: action.payload,
      };
    }
    case types.FETCH_CUSTOM_DATA_EVENT_LIST: {
      return {
        ...state,
        customEventList: [],
      };
    }
    case types.FETCH_CUSTOM_DATA_EVENT_LIST_SUCCESS: {
      return {
        ...state,
        customEventList: action.payload,
      };
    }
    case types.FETCH_CUSTOM_DATA_EVENT_LIST_FAILED: {
      return {
        ...state,
        customEventList: [],
      };
    }
    case types.CLEAR_CUSTOM_EVENT_LIST: {
      return {
        ...state,
        customEventList: [],
      };
    }
    case types.FETCH_CUSTOM_DATA_LIST: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_CUSTOM_DATA_LIST_SUCCESS: {
      return {
        ...state,
        list: action.payload.customDatapoints,
        total: action.payload.total,
        loading: false,
        loaded: true,
      };
    }
    case types.FETCH_CUSTOM_DATA_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        loaded: true,
      };
    }
    case types.CLEAR_CUSTOM_DATA_LIST: {
      return {
        ...state,
        list: [],
        error: null,
        loading: false,
        loaded: false,
      };
    }
    case types.LOAD_MORE_CUSTOM_DATA_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: [...state.list, ...action.payload.customDatapoints],
        total: action.payload.total,
      };
    }
    case types.LOAD_MORE_CUSTOM_DATA_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.CLEAR_ERROR_RESPONSE: {
      return {
        ...state,
        error: null,
        checkCountResponse: null,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT: {
      return {
        ...state,
        checkCountLoading: true,
        checkCountLoaded: false,
        checkCountResponse: null,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT_SUCCESS: {
      return {
        ...state,
        checkCountLoading: false,
        checkCountLoaded: true,
        checkCountResponse: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT_FAILED: {
      return {
        ...state,
        checkCountLoading: false,
        checkCountLoaded: true,
        checkCountResponse: null,
        error: action.payload,
      };
    }

    default:
      return state;
  }
}
